import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from "react";
import { useSearchFilters, useSearchResults, usePagination } from "../../hooks";
import FindVehicleResultsCount from "./find-vehicle-results-count.component";
const FindVehicleResultsCountContainer = (_, ref)=>{
    const { params  } = useSearchFilters();
    const { isLoading , data: searchResults  } = useSearchResults(params);
    const [{ pageItemsRange  }] = usePagination((searchResults === null || searchResults === void 0 ? void 0 : searchResults.pageNumber) || 0, (searchResults === null || searchResults === void 0 ? void 0 : searchResults.pageSize) || 0, (searchResults === null || searchResults === void 0 ? void 0 : searchResults.searchResultsCount) || 0);
    return /*#__PURE__*/ _jsx(FindVehicleResultsCount, {
        searchResultsCount: (searchResults === null || searchResults === void 0 ? void 0 : searchResults.searchResultsCount) || 0,
        pageItemsRange: pageItemsRange,
        fetchStatus: isLoading,
        ref: ref
    });
};
export const FindVehicleResultsCountWrapper = /*#__PURE__*/ forwardRef(FindVehicleResultsCountContainer);
export default FindVehicleResultsCountWrapper;
